import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/(frontend)/[locale]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(frontend)/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/vercel/path0/src/context/posthogProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryProvider"] */ "/vercel/path0/src/context/queryProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReferrerContextProvider"] */ "/vercel/path0/src/context/referrerContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SupabaseProvider"] */ "/vercel/path0/src/context/supabaseContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserFavouritesProvider"] */ "/vercel/path0/src/context/userFavouritesContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/ui/atoms/Icon/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FormBlock"] */ "/vercel/path0/src/ui/blocks/Form/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsConsent"] */ "/vercel/path0/src/ui/components/AnalyticsConsent/AnalyticsConsent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GatedFileButton"] */ "/vercel/path0/src/ui/components/CMSLink/GatedFileButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieBanner"] */ "/vercel/path0/src/ui/components/CookieBanner/CookieBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PopUpButton"] */ "/vercel/path0/src/ui/components/Dialog/popUpButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExitIntentCTA"] */ "/vercel/path0/src/ui/components/ExitIntentCTA/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/src/ui/components/Toast/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ViewTracker"] */ "/vercel/path0/src/ui/components/ViewTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RootGutter"] */ "/vercel/path0/src/ui/layout/Gutter/new/page-layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavBar"] */ "/vercel/path0/src/ui/layout/Header/NavBar/index.tsx");
